import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import appRoutes from '../../routes/appRoutes';
import { auth } from '../../utils/authService';

class NavigationView extends Component {
  state = { displayMobileMenu: false };

  subscription = null;

  didReceiveProfile = (profile) => {
    this.setState({ profile: profile });
  };

  didClickSignOut = () => {
    auth.logout();
    window.location = '/login'; // hard refresh
  };

  didClickMenu = () => {
    this.setState({ displayMobileMenu: !this.state.displayMobileMenu });
  };

  componentWillMount() {
    // state should reflect current profile
    this.subscription = auth.subscribeToProfile(this.didReceiveProfile);
  }

  componentWillUnmount() {
    if (this.subscription) {
      this.subscription.stop();
    }
  }

  render() {
    return (
      <nav role="navigation" onClick={this.didClickMenu}>
        <a className="navigation-menu-button" id="js-mobile-menu">
          MENU
        </a>
        <ul
          id="js-navigation-menu"
          className={
            'navigation-menu ' +
            (this.state.displayMobileMenu ? 'show' : 'hidden')
          }
        >
          <li className="nav-link">
            <Link to={appRoutes.adminsPath()}>Admins</Link>
          </li>
          <li className="nav-link">
            <Link to={appRoutes.brandsPath()}>Brands</Link>
          </li>
          <li className="nav-link">
            <Link to={appRoutes.categoriesPath()}>Categories</Link>
          </li>
          <li className="nav-link dropdown more">
            <a>FastCash</a>
            <ul className="submenu-center">
              <li className="nav-link">
                <Link to={appRoutes.qrCodesPath()}>QR codes</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.transactionsPath()}>FastCash</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.usersPath()}>Users</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.supportPath()}>Support</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.multiBonusPath()}>Bonuses</Link>
              </li>
            </ul>
          </li>
          <li className="nav-link">
            <Link to={appRoutes.happeningsPath()}>Happenings</Link>
          </li>
          <li className="nav-link">
            <Link to={appRoutes.mallInfoPath()}>Mall Info</Link>
          </li>
          <li className="nav-link">
            <Link to={appRoutes.messagesPath()}>Messages</Link>
          </li>
          <li className="nav-link dropdown more">
            <a>Offers</a>
            <ul className="submenu-center">
              <li className="nav-link">
                <Link to={appRoutes.offersPath()}>Offers</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.flashOffersPath()}>Flash Offers</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.topOffersPath()}>Top Offers</Link>
              </li>
            </ul>
          </li>
          <li className="nav-link dropdown more">
            <a>Settings</a>
            <ul className="submenu-center">
              <li className="nav-link">
                <Link to={appRoutes.billingSettingsPath()}>Billing</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.membershipSettingsPath()}>Membership</Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.bannerSettingsPath()}>Banner</Link>
              </li>
            </ul>
          </li>
          <li className="nav-link dropdown more">
            <a>Dashboards</a>
            <ul className="submenu-center">
              <li className="nav-link">
                <Link to={appRoutes.transactionsDashboardPath()}>
                  Transactions
                </Link>
              </li>
              <li className="nav-link">
                <Link to={appRoutes.cashbacksDashboardPath()}>Cashbacks</Link>
              </li>
            </ul>
          </li>
          <li id="js-navigation-more" className="nav-link more">
            <a>{this.state.profile.email}</a>
            <ul className="submenu">
              <li id="sign-out" className="nav-link">
                <a onClick={this.didClickSignOut}>Sign Out</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    );
  }
}

export default withRouter(NavigationView);
